import { useMutateRequest } from "@ch/api/useMutation";
import {
  type MedicationPassport,
  type NewMedicationPassport,
  type NewPrescription,
  PrescriptionControllerService,
} from "@ch/generated";
import useFirebaseAnalytics from "@ch/helpers/utils/firebase/hooks/useFirebaseAnalytics";
import { FirebaseEventEnum } from "@ch/helpers/utils/firebase/types";
import { NotifySuccess } from "@ch/helpers/utils/helpers";
import { useQueryClient } from "@tanstack/react-query";

const useCreatePrescriptionPassport = ({
  payload,
  callback,
}: {
  payload?: {
    prescription?: NewPrescription;
    medicationPassports?: NewMedicationPassport[];
  };
  callback?: (data: MedicationPassport) => void;
}) => {
  const { LogEvent } = useFirebaseAnalytics();
  const queryClient = useQueryClient();
  const { trigger, loading } = useMutateRequest({
    service: PrescriptionControllerService.prescriptionControllerCreate.bind(
      PrescriptionControllerService,
    ),
    tag: "prescriptionControllerCreate",
    payload: {
      requestBody: payload,
    },
    onSuccess: (res) => {
      const data = res as MedicationPassport;
      NotifySuccess("Prescription added successfully!");
      void queryClient.invalidateQueries({
        queryKey: ["usersControllerFetchUserRecentHealthPassport"],
      });
      LogEvent(FirebaseEventEnum.HEALTH_PASSPORT_LOG, {
        passportType: "prescription",
        value: data?.dosage ?? "",
        extra: {
          unit: data?.dosagesUnit,
          frequency: data?.frequency,
        },
      });
      callback?.(data);
    },
  });

  return {
    createPrescriptionPassport: trigger,
    loading,
  };
};

export default useCreatePrescriptionPassport;
